import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestApiService } from '../../shared/services/rest-api.service';
import { ToolbarService } from '../../shared/services/toolbar.service';

import { confirm } from 'devextreme/ui/dialog';
import { Clock } from '../../shared/models/clock';
import { ClockMapMarker } from '../../shared/models/map-marker';
import { Subject, takeUntil } from 'rxjs';
import { HoursOption } from '../../shared/models/hours-option';
import { WorkerAndToolService } from '../../shared/services/worker-and-tool.service';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-clock-detail',
    templateUrl: './clock-detail.component.html',
    styleUrls: ['./clock-detail.component.scss'],
    standalone: false
})
export class ClockDetailComponent {

  option: HoursOption | undefined;

  clock!: Clock;
  clockId: number | null;
  mapMarkers: ClockMapMarker[] = [];

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private service: WorkerAndToolService,
    private restApi: RestApiService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router) {

    this.clockId = null;

    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    let dataRegistrazione = new Date();
    const offset = dataRegistrazione.getTimezoneOffset();
    dataRegistrazione = new Date(dataRegistrazione.getTime() - (offset * 60 * 1000))

    let user = localStorage.getItem("user");
    if (user == null) user = "   ";
    const workerNumber = user.substring(3);

    this.clock = {
      tenantID: +tenantId,
      deviceDate: dataRegistrazione,
      direction: "E",
      workerNumber: workerNumber
    }
  }

  ngOnInit() {
    this.toolbar.backClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Back());
    this.toolbar.deleteClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Delete());
    this.toolbar.editClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Edit());

    this.toolbar.BackVisibleChanged(true);
    this.toolbar.SaveVisibleChanged(false);
    this.toolbar.ForwardVisibleChanged(false);
    this.toolbar.CancelVisibleChanged(false);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(true);

    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => {
      this.option = val;
      if (this.option?.editClock) {
        this.toolbar.EditVisibleChanged(true);
        this.toolbar.CopyVisibleChanged(false);
      }
      else {
        this.toolbar.EditVisibleChanged(false);
        this.toolbar.CopyVisibleChanged(false);
      }
    });

    const regId = this.route.snapshot.paramMap.get('id');
    if (regId != null) this.clockId = +regId;

    if (this.clockId != null) {
      this.toolbar.TitleChanged("Timbratura");

      if (this.clockId > 0) {
        this.restApi.getClock(this.clockId).pipe(takeUntil(this.unsubscribe)).subscribe((clk) => {
          this.clock = clk;
          this.mapMarkers = this.buildMarkers(clk);
        });
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private buildMarkers(clk: Clock): ClockMapMarker[] {
    const result: ClockMapMarker[] = [];
    if (clk.latitudine && clk.longitudine) {
      const clockDate = clk.gpsDate ?? clk.deviceDate;
      const direction = clk.direction ?? '';
      result.push({
        latitude: clk.latitudine,
        longitude: clk.longitudine,
        description: `Timbratura (${direction}) ${formatDate(clockDate, 'HH:mm', this.locale)}`,
        iconType: 'clock'
      });
    }
    if (clk.latitudineCantiere && clk.longitudineCantiere && clk.descrizioneCantiere) {
      result.push({
        latitude: clk.latitudineCantiere,
        longitude: clk.longitudineCantiere,
        description: clk.descrizioneCantiere,
        iconType: 'construction'
      });
    }
    return result;
  }

  Back(): void {
    this.router.navigate(['/clocks']);
  }

  Edit(): void {
    this.router.navigate(['/clock', { id: this.clockId }]);
  }

  Delete(): void {
    const result = confirm("<i>Sei sicuro?</i><br>I dati inseriti andranno persi", "Conferma Cancellazione");
    result.then((dialogResult) => {
      if (dialogResult && this.clockId) {
        this.restApi.deleteClock(this.clockId).pipe(takeUntil(this.unsubscribe)).subscribe(() => this.router.navigate(['/clocks']));
      }
    });
  }
}
